"use client";

import React, { ReactElement, ReactNode, useEffect, useRef } from "react";
import useFilterContext from "../hooks/useFilterContext";
import SearchField from "./SearchField";

export interface FreeTextFilterCardProps {
  placeholder: string;
  searchParamName: string;
  info?: string | ReactElement;
  children?: ReactNode;
  onEnter?: () => void; // Add onEnter prop
}

const FreeTextFilterCard: React.FC<FreeTextFilterCardProps> = ({
  placeholder,
  info = null,
  searchParamName,
  onEnter = null,
  children,
}) => {
  const { formState, setFilterValues } = useFilterContext();
  const searchInputRef = useRef(null);
  const [currentValue] = formState[searchParamName] || [];

  const onSearch = (value) => {
    const values = [value].filter(Boolean);
    setFilterValues(searchParamName, values);
  };

  useEffect(() => {
    if (currentValue === undefined) {
      searchInputRef?.current?.reset();
    }
  }, [currentValue]);

  return (
    <div className="mt-4 mb-2">
      <span className="mb-2 d-block fs-8">{info}</span>
      <div className="position-relative">
        <SearchField
          ref={searchInputRef}
          placeholder={placeholder}
          onSearch={onSearch}
          updateOnChange
          defaultValue={currentValue}
          onEnter={onEnter}
        />
        {children}
      </div>
    </div>
  );
};

export default FreeTextFilterCard;
